import { render, staticRenderFns } from "./venueList.vue?vue&type=template&id=2049eb25&scoped=true"
import script from "./venueList.vue?vue&type=script&lang=js"
export * from "./venueList.vue?vue&type=script&lang=js"
import style0 from "./venueList.vue?vue&type=style&index=0&id=2049eb25&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2049eb25",
  null
  
)

export default component.exports